import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, HStack, Text } from '@chakra-ui/react'
import { themeColors } from 'theme'

import ButtonBox from 'components/ButtonBox'
import { CardBody, CardContainer } from 'components/CustomCard'
import { ChevronRightIcon, HomeIcon, KaufmannIcon } from 'components/SVGS'

export const Appointment = () => {
  const navigate = useNavigate()
  const [selectedAppointment, setSelectedAppointment] = useState<'home' | 'branches' | null>(null)
  const [isHover, setIsHover] = useState(false)

  const { icon: { secondaryIconColor } } = themeColors

  const handleSubmit = (selectedAppointment: 'home' | 'branches' | null) => {
    switch (selectedAppointment) {
      case 'home':
        window.open('https://lp.wicar.cl/meetings/agenda-domicilio1/agenda-instalacion-wicar')
        navigate('/')
        break
      case 'branches':
        window.open('https://reservas.kaufmann.cl')
        navigate('/')
        break
      default:
        window.open('https://reservas.kaufmann.cl')
        navigate('/')
        break
    }
  }

  return (
    <CardContainer  >
      <CardBody>
        <Text variant={'LG_SB'} textAlign={'center'}>
          Solicita la agenda para la instalar el dispositivo WiCar
        </Text>
        <Text>
          Elige la modalidad de instalación y te enviaremos la agenda a tu correo.
        </Text>
        <HStack>
          <ButtonBox
            disabled={false}
            icon={KaufmannIcon}
            {...selectedAppointment === 'branches' && { isActive: true }}
            {...selectedAppointment === 'branches'
              ? { secondFill: 'white' }
              : isHover ? { secondFill: 'white' } : { secondFill: 'black' }}
            onClick={() => setSelectedAppointment('branches')}
            textProps={{ variant: 'SM' }}
            buttonProps={{ onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false) }}
          >
            Sucursales {'\n'}
            Kaufmann {'\n'}
            (Regiones)
          </ButtonBox>
          <ButtonBox
            disabled={false}
            icon={HomeIcon}
            {...selectedAppointment === 'home' && { isActive: true }}
            onClick={() => setSelectedAppointment('home')}
            textProps={{ variant: 'SM' }}>
            Instalación {'\n'}
            domicilio {'\n'}
            <Text variant='SM' color={'currentcolor'}>(solo Santiago)</Text>
          </ButtonBox>
        </HStack>
        <Button
          onClick={() => handleSubmit(selectedAppointment)}
          disabled={!selectedAppointment}
          rightIcon={<ChevronRightIcon fill={secondaryIconColor} />}>
          solicitar agenda
        </Button>
      </CardBody>
    </CardContainer >
  )
}
